<template>
    <div>

        <ly-form-item :label="item.label" v-for="(item, index) in eventList" :key="index">
            {{ item.processResult }}
            <imgList :data="item.picList"></imgList>

        </ly-form-item>


    </div>
</template>
<script>

export default {
    props: ['data'],
    data() {
        return {
            item: {
                picList: [],
                filePathList: [{
                    fileList: [],
                    reamrk: ''
                }
                ]
            },
            eventList: []
        }
    },
    methods: {
        load() {
            //console.log(this.data.label, this.data);

            var t = this.data.eventList;
            if (!this.utils.isEmpty(t)) {
                for (let i = 0; i < t.length; i++) {
                    if (t[i].label == "过海关") {
                        t[i].processResult = this.utils.time(t[i].createTime)
                    }
                    t[i].picList = [];
                    if (!this.utils.isEmpty(t[i].filePathList)) {
                        t[i].picList = t[i].filePathList[0].fileList;
                    }

                }

                // 
                // this.eventList = t;
                // this.item.picList = this.data.filePathList[0].fileList;
            }
            // console.log('事件列表', t);
            this.eventList = t;
            // 
        }
    },
    mounted() {
        this.load();
    }
}
</script>
<style>
.caijian {
    width: 60px;
    height: 60px;
    margin-right: 4px;
    object-fit: cover;
    /* 裁剪并覆盖到容器 */
    object-position: center;
}
</style>


// WEBPACK FOOTER //
// src/components/diaodu/jincheng/event.vue